import axios from 'axios';
import authHeader from './auth-header';
import RetryPolicy from './RetryAuthProblems'

const API_URL = process.env.REACT_APP_API_URL;
const axiosApiInstanceForValidation = axios.create();

axiosApiInstanceForValidation.interceptors.response.use(response => {
    return response;
}, async error => RetryPolicy(error));

class LicenseRequestsService {

    getLicenseRequests() {
        return axiosApiInstanceForValidation.get(API_URL + '/V3/LicenseRequests', { headers: authHeader() });
    }
    
    getLicenseRequestsFiltered(filter, orderBy, page, pageSize) {

        let filterToSend = "";

        if (orderBy)
            filterToSend = orderBy;


        if (page)
            if (filterToSend !== "")
                filterToSend += "&page=" + page;
            else
                filterToSend = "?page=" + page;

        if (pageSize)
            if (filterToSend !== "")
                filterToSend += "&pageSize=" + pageSize;
            else
                filterToSend = "?pageSize=" + pageSize;

        if (filter)
            if (filterToSend !== "")
                filterToSend += "&filter=" + filter;
            else
                filterToSend = "?filter=" + filter;

        return axiosApiInstanceForValidation.get(API_URL + '/V3/LicenseRequests' + filterToSend, { headers: authHeader() });
    }

    getLicenseRequest(licenseRequestId) {
        return axiosApiInstanceForValidation.get(API_URL + '/V3/LicenseRequests/' + licenseRequestId, { headers: authHeader() });
    }

    deleteLicenseRequest(licenseRequestId) {
        return axiosApiInstanceForValidation.delete(API_URL + '/V3/LicenseRequests/' + licenseRequestId, { headers: authHeader() });
    }

    updateLicenseRequest(licenseRequestId, LicenseRequest) {
        return axiosApiInstanceForValidation.put(API_URL + '/V3/LicenseRequests/' + licenseRequestId, LicenseRequest, { headers: authHeader() });
    }

    insertLicenseRequest(LicenseRequest) {
        return axiosApiInstanceForValidation.post(API_URL + '/V3/LicenseRequests', LicenseRequest, { headers: authHeader() });
    }
    
    async getListOfApplications() {

        let getTotal = await axiosApiInstanceForValidation.get(API_URL + '/V3/Applications/', { headers: authHeader() });
        let getListOfApps = await axiosApiInstanceForValidation.get(API_URL + '/V3/Applications/?pageSize='+ getTotal.data.totalResults+'&orderBy=ApplicationName', { headers: authHeader() });
        return getListOfApps.data.contract;

    }
}

export default new LicenseRequestsService();
